import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm, useWatch } from "react-hook-form";
import Breadcrumb from '../../../components/layout/Breadcrumb';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useHasPermission } from '../../../hooks/useHasPermission';

export default function Post() {
    const navigate = useNavigate();
   const {
    register, handleSubmit, onSubmit, reset, clearErrors, setValue, 
    formState: { errors }, setError, control  // Add formState wrapper
} = useForm();
    const [postTitleColor, setPostTitleColor] = useState("#d3d3d3");
    const [customErrorForPostDescInput, setCustomErrorForPostDescInput] = useState('');
    const canView = useHasPermission("Add Post-view");
    const canEdit = useHasPermission("Add Post-manage");
    const watchedValues = useWatch({
        control,
        name: ["postTitle", "postDescription"],
    });
    const [postTitle, postDescription] = watchedValues;
    const hasErrors = Object.keys(errors).length > 0;
    const isApplyPostDisabled = !canEdit || !postTitle || !postDescription || hasErrors;
    const isCancelPostDisabled = !postTitle && !postDescription;

    if (!canView) return <p className='perm-msg'>{"You don't have permission to add post!"}</p>;

    const handlePostCancel = () => {
        reset();
        setPostTitleColor("#d3d3d3");
        clearErrors("postDescription");
    };

    const handlePostTitleColorChange = (e) => {
        const selectedValue = e.target.value;
        setValue("postTitle", selectedValue);
        setPostTitleColor(selectedValue ? "black" : "#d3d3d3");
    };

    const handlePatternForPostDescInput = (e) => {
        let value = e.target.value;
        clearErrors("postDescription");
        setValue("postDescription", value);

        let patternErrorMessage = '';
        const postDescRegex = /^[a-zA-Z0-9\s.,!?'"()&-]+$/;

        if (value && !postDescRegex.test(value)) {
            patternErrorMessage = 'No special characters are allowed';
            setError("postDescription", { type: "pattern", message: patternErrorMessage });
        } else {
            clearErrors("postDescription");
        }

        setCustomErrorForPostDescInput(prev => ({ ...prev, postDescription: patternErrorMessage }));
        if (!patternErrorMessage) {
            setCustomErrorForPostDescInput(prev => ({ ...prev, postDescription: '' }));
            clearErrors("postDescription");
        }
    };

    const handleFormSubmit = async (data) => {
        if (!canEdit) {
            alert("You do not have permission to add post.");
            return;
        }
        if (Object.keys(errors).length > 0) {
            return;
        }
        onSubmit(data);
        reset();
        setTimeout(() => {
            navigate('/admin/Dashboard');
        }, 2000);
        toast.success("Posted successfully! ");
        setPostTitleColor("#d3d3d3");
    };
    const descErrMsg = errors.postDescription?.message || customErrorForPostDescInput.postDescription;

    return (
        <div className='container-fluid'>
            <div className='row clearfix'>
                <div className='col-md-12'>
                    <Breadcrumb />
                    <div className='attendance-container' style={{ padding: '0', marginBottom: '45px', marginTop: '34px' }}>
                        <form onSubmit={
                            canEdit
                                ? handleSubmit(handleFormSubmit)
                                : (e) => { e.preventDefault(); toast.error("No permission to add post"); }}>
                            <h4 className='apply-leave-heading'>Post</h4>
                            <div className='apply-leave-section'>
                                <div className="input-text">
                                    <p className='applyLeaveLabel'>Title<span style={{ color: "red" }}>*</span></p>
                                    <div className="user-input-icons">
                                        <select className="input-field" name='newUserRole' {...register("postTitle", { required: 'Please choose the job role' })}
                                            onChange={handlePostTitleColorChange} style={{ color: postTitleColor }}>
                                            <option value="" hidden style={{ color: "#d3d3d3" }}>Select the post title</option>
                                            <option style={{ color: 'black' }}>Announcement</option>
                                            <option style={{ color: 'black' }}>Warm wishes</option>
                                            <option style={{ color: 'black' }}>Notice</option>
                                            <option style={{ color: 'black' }}>Exciting Updates</option>
                                            <option style={{ color: 'black' }}>Fun Activity Alert</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="input-text" style={{ marginTop: '5px' }}>
                                    <p className='applyLeaveLabel'>Description<span style={{ color: "red" }}>*</span></p>
                                    <div className="user-input-icons">
                                        <textarea rows="4" className="input-field" {...register("postDescription", {
                                            required: true,
                                            minLength: { value: 3, message: "Description must be at least three characters" },
                                            maxLength: { value: 100, message: "Description must not exceed hundred characters" },
                                        })}
                                            onChange={(e) => handlePatternForPostDescInput(e)} >
                                        </textarea>
                                        {descErrMsg && <div className="errorMessage">{descErrMsg}</div>}
                                    </div>
                                    <div className='edit-delete-btn-container' style={{ marginTop: '0' }}>
                                        <button className="primary-btn" style={{ background: 'darkgray', width: '100px' }} disabled={isCancelPostDisabled} onClick={() => handlePostCancel()}>Cancel</button>
                                        <button className="primary-btn" type="submit" style={{ width: '100px' }}
                                            title={
                                                canEdit
                                                    ? "add post"
                                                    : "No permission to add post"
                                            }
                                            disabled={!canEdit || isApplyPostDisabled}
                                        >Submit</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div >
    )
}
